require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppbarHeader = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _overlay = _interopRequireDefault(require("../../styles/overlay"));

var _Appbar = _interopRequireWildcard(require("./Appbar"));

var _shadow = _interopRequireDefault(require("../../styles/shadow"));

var _theming = require("../../core/theming");

var _constants = require("../../constants");

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/Appbar/AppbarHeader.tsx";

var AppbarHeader = function (_React$Component) {
  (0, _inherits2["default"])(AppbarHeader, _React$Component);

  function AppbarHeader() {
    (0, _classCallCheck2["default"])(this, AppbarHeader);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(AppbarHeader).apply(this, arguments));
  }

  (0, _createClass2["default"])(AppbarHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$statusBar = _this$props.statusBarHeight,
          statusBarHeight = _this$props$statusBar === void 0 ? _constants.APPROX_STATUSBAR_HEIGHT : _this$props$statusBar,
          style = _this$props.style,
          dark = _this$props.dark,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["statusBarHeight", "style", "dark"]);
      var _rest$theme = rest.theme,
          isDarkTheme = _rest$theme.dark,
          colors = _rest$theme.colors,
          mode = _rest$theme.mode;

      var _ref = _reactNative.StyleSheet.flatten(style) || {},
          _ref$height = _ref.height,
          height = _ref$height === void 0 ? _Appbar.DEFAULT_APPBAR_HEIGHT : _ref$height,
          _ref$elevation = _ref.elevation,
          elevation = _ref$elevation === void 0 ? 4 : _ref$elevation,
          customBackground = _ref.backgroundColor,
          _ref$zIndex = _ref.zIndex,
          zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex,
          restStyle = (0, _objectWithoutProperties2["default"])(_ref, ["height", "elevation", "backgroundColor", "zIndex"]);

      var backgroundColor = customBackground ? customBackground : isDarkTheme && mode === 'adaptive' ? (0, _overlay["default"])(elevation, colors.surface) : colors.primary;
      var Wrapper = typeof this.props.statusBarHeight === 'number' ? _reactNative.View : _reactNative.SafeAreaView;
      return React.createElement(Wrapper, {
        style: [{
          backgroundColor: backgroundColor,
          zIndex: zIndex,
          elevation: elevation
        }, (0, _shadow["default"])(elevation)],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 113
        }
      }, React.createElement(_Appbar["default"], (0, _extends2["default"])({
        style: [{
          height: height,
          backgroundColor: backgroundColor,
          marginTop: statusBarHeight
        }, styles.appbar, restStyle],
        dark: dark
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 121
        }
      })));
    }
  }]);
  return AppbarHeader;
}(React.Component);

exports.AppbarHeader = AppbarHeader;
(0, _defineProperty2["default"])(AppbarHeader, "displayName", 'Appbar.Header');

var styles = _reactNative.StyleSheet.create({
  appbar: {
    elevation: 0
  }
});

var _default = (0, _theming.withTheme)(AppbarHeader);

exports["default"] = _default;